export class FacilityDetailLight {
    id: number;
    name: string;
    defaultAssigneeId: string;
}
